import { render, staticRenderFns } from "./PositionCard.vue?vue&type=template&id=335d9113&scoped=true"
import script from "./PositionCard.vue?vue&type=script&lang=js"
export * from "./PositionCard.vue?vue&type=script&lang=js"
import style0 from "./PositionCard.vue?vue&type=style&index=0&id=335d9113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d9113",
  null
  
)

export default component.exports